export default __webpack_public_path__ + "static/media/arrowLeft.af99b431.svg";